import React from 'react';
import { ClipboardList, PlayCircle, CheckCircle2, Check } from 'lucide-react';

const PHASES = [
  { id: 'plan',     label: 'Plan',       Icon: ClipboardList,  desc: 'Scope, hazards, HP tools, PPE.' },
  { id: 'perform',  label: 'Perform',    Icon: PlayCircle,     desc: 'Live work, critical steps, hold points.' },
  { id: 'closeout', label: 'Close Out',  Icon: CheckCircle2,   desc: 'Restoration, handoff, lessons learned.' },
];

/**
 * PhaseIndicator — Plan / Perform / Close Out chevron strip.
 * Purely presentational: parent passes `current` and (optionally)
 * an `onChange` callback for click-to-jump behavior.
 */
export default function PhaseIndicator({ current, completed = [], onChange }) {
  const currentIdx = PHASES.findIndex((p) => p.id === current);
  return (
    <nav
      className="jbv2-phase-strip"
      aria-label="Job Brief phase progress"
      data-testid="jbv2-phase-indicator"
    >
      {PHASES.map((p, i) => {
        const done   = completed.includes(p.id) || i < currentIdx;
        const isCur  = p.id === current;
        const Icon   = done ? Check : p.Icon;
        return (
          <button
            key={p.id}
            type="button"
            onClick={() => onChange?.(p.id)}
            className={`jbv2-phase ${isCur ? 'jbv2-phase--current' : ''} ${done ? 'jbv2-phase--done' : ''}`}
            data-testid={`jbv2-phase-${p.id}`}
            aria-current={isCur ? 'step' : undefined}
          >
            <span className="jbv2-phase-num" aria-hidden="true">
              <Icon size={14} strokeWidth={2.6} />
            </span>
            <span className="jbv2-phase-body">
              <span className="jbv2-phase-label">{p.label}</span>
              <span className="jbv2-phase-desc">{p.desc}</span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}

export { PHASES };
